// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.employee-invite {
  margin-top: 50px;
}
.employee-invite__background {
  background: #f5f5f5;
  height: 100vh;
}
.employee-invite__card-profile-changes {
  margin: auto;
  background-color: #ffffff;
  border: 1px solid #f3f5f6;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
}
.employee-invite__table__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
  border-top: 1px solid #868686;
}
.employee-invite__table__head-center {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  color: #868686;
  padding-left: 10px;
  border-top: 1px solid #868686;
}
.employee-invite__table__td-bold {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  color: #505054;
  border-top: 1px solid #E9E9E9;
}
.employee-invite__table__td {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  color: #505054;
  border-top: 1px solid #E9E9E9;
}
.employee-invite__table__td-center {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  text-align: center;
  color: #505054;
  border-top: 1px solid #E9E9E9;
  cursor: pointer;
}
.employee-invite__head {
  background: #f5f5f5;
  margin-bottom: 30px;
}
.employee-invite__head__head-text {
  padding-top: 10px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
}
.employee-invite__head__subhead-text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
  padding-top: 10px;
}
.employee-invite__body {
  padding-top: 30px;
}
.employee-invite__body__table {
  width: 100%;
}
.employee-invite__body__left {
  width: 65%;
  border-right: 1px solid #e9e9e9;
}
.employee-invite__body__right {
  width: 35%;
  padding: 3%;
}

.form-cards {
  width: 100%;
  background: #f5f5f5;
  padding-bottom: 25px;
}

.excel-form {
  padding: 5%;
}
.excel-form__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #353d47;
}
.excel-form__form {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #353d47;
}
.excel-form__date {
  display: flex;
  width: 100%;
}

.info__part2 {
  margin-top: 100px;
}
.info__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #666666;
}
.info__body {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}

.download {
  margin-top: 20px;
}

.invitation-list {
  margin-top: 15px;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  padding: 20px;
}
.invitation-list__head {
  display: flex;
}
.invitation-list__head__heading {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #333333;
  margin-bottom: 25px;
}
.invitation-list__head__number {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #49ae9e;
  margin-bottom: 25px;
  margin-left: 5px;
}
.invitation-list__head__buttons {
  margin-left: auto;
  display: flex;
}

.search-icon {
  position: relative;
  z-index: 0;
}
.search-icon__icon {
  position: absolute;
  right: 20px;
  top: 10px;
}
.search-icon__search {
  height: 34px;
  width: 150px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  padding-left: 10px;
  margin-left: 10px;
  margin-right: 10px;
}

.order__select {
  height: 30px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  width: 100px;
}

.order-button {
  height: 30px;
  width: 60px;
  background: #49ae9e;
  border-radius: 6px;
  border: none;
  text-align: center;
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/components/employee-registration/bulk-registration/bulk-registration.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;AACI;EACI,mBAAA;EACA,aAAA;AACR;AAEI;EACI,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,4CAAA;EACA,kBAAA;AAAR;AAIQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,6BAAA;AAFZ;AAKQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;AAHZ;AAMQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,6BAAA;AAJZ;AAOQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,6BAAA;AALZ;AAQQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;EACA,eAAA;AANZ;AAYI;EACI,mBAAA;EACA,mBAAA;AAVR;AAYQ;EACI,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAVZ;AAaQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAXZ;AAeI;EACI,iBAAA;AAbR;AAeQ;EACI,WAAA;AAbZ;AAgBQ;EACI,UAAA;EACA,+BAAA;AAdZ;AAiBQ;EACI,UAAA;EACA,WAAA;AAfZ;;AAoBA;EACI,WAAA;EACA,mBAAA;EACA,oBAAA;AAjBJ;;AAoBA;EACI,WAAA;AAjBJ;AAmBI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAjBR;AAoBI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAlBR;AAqBI;EACI,aAAA;EACA,WAAA;AAnBR;;AAwBI;EACI,iBAAA;AArBR;AAwBI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAtBR;AAyBI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAvBR;;AA2BA;EACI,gBAAA;AAxBJ;;AA2BA;EACI,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AAxBJ;AA0BI;EACI,aAAA;AAxBR;AA0BQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,mBAAA;AAzBZ;AA4BQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,mBAAA;EACA,gBAAA;AA3BZ;AA8BQ;EACI,iBAAA;EACA,aAAA;AA5BZ;;AAiCA;EACI,kBAAA;EACA,UAAA;AA9BJ;AAgCI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AA9BR;AAiCI;EACI,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AA/BR;;AAoCI;EACI,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AAjCR;;AAqCA;EACI,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAlCJ","sourcesContent":[".employee-invite {\n    margin-top: 50px;\n\n    &__background {\n        background: #f5f5f5;\n        height: 100vh;\n    }\n\n    &__card-profile-changes {\n        margin: auto;\n        background-color: #ffffff;\n        border: 1px solid #f3f5f6;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n        border-radius: 8px;\n    }\n\n    &__table {\n        &__head {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            color: #868686;\n            border-top: 1px solid #868686;\n        }\n\n        &__head-center {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            align-items: center;\n            color: #868686;\n            padding-left: 10px;\n            border-top: 1px solid #868686;\n        }\n\n        &__td-bold {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            align-items: center;\n            color: #505054;\n            border-top: 1px solid #E9E9E9;\n        }\n\n        &__td {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            align-items: center;\n            color: #505054;\n            border-top: 1px solid #E9E9E9;\n        }\n\n        &__td-center {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            align-items: center;\n            text-align: center;\n            color: #505054;\n            border-top: 1px solid #E9E9E9;\n            cursor: pointer;\n        }\n    }\n\n    \n\n    &__head {\n        background: #f5f5f5;\n        margin-bottom: 30px;\n\n        &__head-text {\n            padding-top: 10px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n        }\n\n        &__subhead-text {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            color: #868686;\n            padding-top: 10px;\n        }\n    }\n\n    &__body {\n        padding-top: 30px;\n\n        &__table {\n            width: 100%;\n        }\n\n        &__left {\n            width: 65%;\n            border-right: 1px solid #e9e9e9;\n        }\n\n        &__right {\n            width: 35%;\n            padding: 3%;\n        }\n    }\n}\n\n.form-cards {\n    width: 100%;\n    background: #f5f5f5;\n    padding-bottom: 25px;\n}\n\n.excel-form {\n    padding: 5%;\n\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 20px;\n        line-height: 30px;\n        color: #353d47;\n    }\n\n    &__form {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 20px;\n        line-height: 30px;\n        color: #353d47;\n    }\n\n    &__date {\n        display: flex;\n        width: 100%;\n    }\n}\n\n.info {\n    &__part2 {\n        margin-top: 100px;\n    }\n\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #666666;\n    }\n\n    &__body {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        color: #999999;\n    }\n}\n\n.download {\n    margin-top: 20px;\n}\n\n.invitation-list {\n    margin-top: 15px;\n    border: 1px solid #e9e9e9;\n    border-radius: 8px;\n    padding: 20px;\n\n    &__head {\n        display: flex;\n\n        &__heading {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 18px;\n            line-height: 24px;\n            color: #333333;\n\n            margin-bottom: 25px;\n        }\n\n        &__number {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 18px;\n            line-height: 24px;\n            color: #49ae9e;\n\n            margin-bottom: 25px;\n            margin-left: 5px;\n        }\n\n        &__buttons {\n            margin-left: auto;\n            display: flex;\n        }\n    }\n}\n\n.search-icon {\n    position: relative;\n    z-index: 0;\n\n    &__icon {\n        position: absolute;\n        right: 20px;\n        top: 10px;\n    }\n\n    &__search {\n        height: 34px;\n        width: 150px;\n        background: #ffffff;\n        border: 1px solid #e9e9e9;\n        border-radius: 8px;\n        padding-left: 10px;\n        margin-left: 10px;\n        margin-right: 10px;\n    }\n}\n\n.order {\n    &__select {\n        height: 30px;\n        background: #ffffff;\n        border: 1px solid #e9e9e9;\n        border-radius: 8px;\n        width: 100px;\n    }\n}\n\n.order-button {\n    height: 30px;\n    width: 60px;\n    background: #49ae9e;\n    border-radius: 6px;\n    border: none;\n    text-align: center;\n    color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
